"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoginModal = require("./LoginModal");

var _LoginModal2 = _interopRequireDefault(_LoginModal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = _LoginModal2.default;